const CATEGORY_KEYS = ["breakfast", "lunch", "dinner", "snack"];

export function getMealCategories(meal) {
  return CATEGORY_KEYS.filter((key) => meal[key]).map(
    (key) => key.charAt(0).toUpperCase() + key.slice(1),
  );
}
